import React from "react";
import { Link } from "react-router-dom";
import phoenixLogo from "../../img/logo.png";
import maharashtraPoliceLogo from "../../img/Maharashtra-police-logo.png";
import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-column">
          <h3 className="footer-heading">ENCIPHERX 4.0</h3>
          <p className="footer-description">
            A 24-hour Capture The Flag competition organized by Phoenix
            Cybersecurity, challenging participants across 10 cybersecurity
            domains.
          </p>
          <div className="footer-info">
            <p className="footer-venue">
              St. Vincent Pallotti College of Engineering & Technology, Nagpur
            </p>
            <p className="footer-date">February 7-8, 2026</p>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">QUICK LINKS</h3>
          <div className="footer-links">
            <Link to="/" className="footer-link">
              Home
            </Link>
            <Link to="/about" className="footer-link">
              About
            </Link>
            <Link to="/mission-briefing" className="footer-link">
              Rules and Regulations
            </Link>
            <Link to="/sponsors" className="footer-link">
              Sponsors
            </Link>
            <Link to="/register" className="footer-link">
              Register
            </Link>
          </div>
          <div className="footer-organizer">
            <h4 className="footer-subheading">ORGANIZED BY</h4>
            <div className="organizer-logo-container">
              <img
                src={phoenixLogo}
                alt="Phoenix Cybersecurity Logo"
                className="phoenix-logo"
              />
              <p className="organizer-name">PHOENIX CYBER SECURITY</p>
            </div>
            <p className="organizer-event">ENCIPHERX 4.0</p>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">CONNECT WITH US</h3>
          <div className="footer-contact">
            <div className="contact-item">
              <span className="contact-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </span>
              <a
                href="mailto:phoenixcybersec008@gmail.com"
                className="contact-link"
              >
                phoenixcybersec008@gmail.com
              </a>
            </div>
            <div className="contact-item">
              <span className="contact-icon">
                <svg
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <circle cx="12" cy="12" r="10" />
                  <line x1="2" y1="12" x2="22" y2="12" />
                  <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                </svg>
              </span>
              <a
                href="https://phoenixcybersec.in"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                phoenixcybersec.in
              </a>
            </div>
          </div>
          <div className="social-media">
            <a
              href="https://www.instagram.com/phoenix_cybersec?igsh=eHp0ODFrMG42am43"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="Instagram"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <rect x="2" y="2" width="20" height="20" rx="5" />
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
              </svg>
            </a>
            <a
              href="https://www.linkedin.com/company/phoenix-cybersec/posts/?feedView=all"
              target="_blank"
              rel="noopener noreferrer"
              className="social-icon"
              aria-label="LinkedIn"
            >
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z" />
                <rect x="2" y="9" width="4" height="12" />
                <circle cx="4" cy="4" r="2" />
              </svg>
            </a>
          </div>
        </div>

        <div className="footer-column">
          <h3 className="footer-heading">LAW ENFORCEMENT PARTNER</h3>
          <div className="footer-partner">
            <div className="partner-logo-container">
              <img
                src={maharashtraPoliceLogo}
                alt="Maharashtra Police Logo"
                className="police-logo"
              />
            </div>
            <p className="partner-name">Nagpur Police</p>
            <p className="partner-description">
              Collaboration & case study sessions
            </p>
          </div>
        </div>
      </div>
      <div className="footer-copyright">
        <p>
          © 2026 Phoenix Cybersecurity. All rights reserved. | EncipherX 4.0
        </p>
        <p className="powered-by">
          Powered by{" "}
          <a
            href="https://unstop.com/p/encipherx-40-ctf-st-vincent-pallotti-college-of-engineering-and-technology-svpcet-nagpur-1620651?utm_medium=Share&utm_source=adityjad46927&utm_campaign=Online_coding_challenge"
            target="_blank"
            rel="noopener noreferrer"
            className="unstop-link"
          >
            Unstop
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
